export default __webpack_public_path__ + "static/media/art1.350dcfe8.svg";